import { get, writable } from "svelte/store"
import { generateSessionCode } from "./cobrowse"

export const sessionCode = writable<string | null>(null)
export const sessionLoading = writable(false)

export async function requestSessionCode(
  onError?: (error: unknown) => void
): Promise<void> {
  if (get(sessionLoading)) return
  sessionLoading.set(true)
  try {
    sessionCode.set(await generateSessionCode())
  } catch (error) {
    onError?.(error)
  } finally {
    sessionLoading.set(false)
  }
}
